import React from 'react';
import Stack from '../../../../../../v2BaseComponents/Stack';
import { View } from 'react-native';
import Text from '../../../../../../v2BaseComponents/Text';
import { colors } from '../../../../../../../utils/theme';

export type BrandingColorDisplayOwnProps = {
    color: string;
    label: string;
};

export type BrandingColorDisplayProps = BrandingColorDisplayOwnProps;

const BrandingColorDisplay: React.FC<BrandingColorDisplayProps> = (props) => {
    return (
        <Stack horizontal space={6} justify="flex-start" align="center">
            <View
                style={{
                    width: 20,
                    height: 20,
                    backgroundColor: props.color,
                    borderRadius: 4,
                    borderColor: colors.Dividers,
                    borderWidth: 1,
                }}
            />
            <Text variant="body-1">{`${props.label} (${props.color})`}</Text>
        </Stack>
    );
};

export default React.memo(BrandingColorDisplay);
